'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _ThemeHelper = require('helpers/theme/ThemeHelper');

var _ThemeHelper2 = _interopRequireDefault(_ThemeHelper);

var _wish_list = require('redux/actions/wish_list');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ShortDescription: {
        displayName: 'ShortDescription'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/CartProduct/ShortDescription/ShortDescription.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ShortDescription = _wrapComponent('ShortDescription')((_dec = (0, _reactRedux.connect)(function (state) {
    return {};
}, { wishListUpdateProduct: _wish_list.wishListUpdateProduct }), _dec(_class = function (_Component) {
    (0, _inherits3.default)(ShortDescription, _Component);

    function ShortDescription() {
        (0, _classCallCheck3.default)(this, ShortDescription);
        return (0, _possibleConstructorReturn3.default)(this, (ShortDescription.__proto__ || (0, _getPrototypeOf2.default)(ShortDescription)).apply(this, arguments));
    }

    (0, _createClass3.default)(ShortDescription, [{
        key: 'render',
        value: function render() {
            var View = _ThemeHelper2.default.getViewForComponent('ShortDescription', null, { folderName: 'CartProduct/ShortDescription' });
            if (this.props.product_detail.catalog.profile.currency_id === 933) {
                this.props.product_detail.price = parseFloat(this.props.product_detail.price).toFixed(4);
            } else {
                this.props.product_detail.price = parseFloat(this.props.product_detail.price).toFixed(2);
            }
            return _react3.default.createElement(View, this.props);
        }
    }]);
    return ShortDescription;
}(_react2.Component)) || _class));

exports.default = ShortDescription;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/ShortDescription/ShortDescription.jsx
// module id = 1630
// module chunks = 0